import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { cargarNotaria } from "../actions/notariaAction";
import { apiService } from "../config.js";
import CotizadorCore from "components/Cotizador";
import logo from "assets/img/notarias/logo27.png";

const Cotizador = () => {
  const dispatch = useDispatch();
  const notaria = useSelector((state) => state.notaria.notaria);
  const [servicios, setServicios] = React.useState([]);

  React.useEffect(() => {
    const consultar = async () => {
      try {
        const resultado = await apiService.getNotaria();
        if (resultado.status === 200) {
          const dataTemp = {};
          resultado.data.forEach((element) => {
            dataTemp[element.variable] = element.value;
          });
          dispatch(cargarNotaria(dataTemp));
        }
      } catch (error) {
        console.error("Error al consultar la notaria:", error.message);
      }
    };

    consultar();
  }, [dispatch]);

  React.useEffect(() => {
    const consultarServicios = async () => {
      try {
        const resultado = await apiService.getConfigCotizador();
        setServicios(Array.isArray(resultado.data) ? resultado.data : []);
      } catch (error) {
        console.error("Error al consultar servicios:", error.message);
      }
    };

    consultarServicios();
  }, []);

  return (
    <div className="wrapper">
      <CotizadorCore
      notaria={notaria || {}}
      serviciosIniciales={servicios}
      onCotizar={apiService.cotizarPublico}
      logoSrc={logo}
    />
    </div>
  );
};

export default Cotizador;